
import { Notification } from "@/types/notification";
import { toast } from "@/components/ui/use-toast";

export const showNotificationToast = (title: string, message: string) => {
  toast({
    title,
    description: message,
  });
};

export const getUnreadCount = (notifications: Notification[]): number => {
  return notifications.filter(notif => !notif.isRead).length;
};

export const DEFAULT_NOTIFICATIONS: Notification[] = [
  {
    id: 1,
    title: "Νέο υλικό διαθέσιμο!",
    message: "Προστέθηκε ένα νέο βίντεο \"Εισαγωγή στη Λογιστική\"",
    isRead: false,
    date: new Date(),
    isPremiere: true
  },
  {
    id: 2,
    title: "Πρεμιέρα: Φορολογικές Δηλώσεις",
    message: "Νέος οδηγός για τις φορολογικές δηλώσεις",
    isRead: false,
    date: new Date(Date.now() - 86400000),
    isPremiere: true
  }
];
